import { useState } from "react";
import { answerReview } from "@worktools/shared";
import { useBoard } from "../sync/BoardContext";
import { useMyPendingReviews } from "../sync/hooks";
import { useDialogs } from "../ui/dialogs";
import { IconCheck, IconChevron } from "./icons";

/** Claude reports finished work here; only its own owner sees and answers it. */
export function ReviewPanel() {
  const { doc } = useBoard();
  const dialogs = useDialogs();
  const reviews = useMyPendingReviews();
  const [feedbackFor, setFeedbackFor] = useState<string | null>(null);
  const [feedback, setFeedback] = useState("");

  if (reviews.length === 0) return null;
  const review = reviews[0];
  const askingForChanges = feedbackFor === review.id;

  const approve = () => {
    answerReview(doc, review.id, { status: "approved" });
    dialogs.toast("Freigegeben — Claude arbeitet weiter", "ai");
  };

  const sendFeedback = () => {
    const text = feedback.trim();
    if (!text) return;
    answerReview(doc, review.id, { status: "changes_requested", feedback: text });
    setFeedback("");
    setFeedbackFor(null);
    dialogs.toast("Feedback an Claude gesendet", "ai");
  };

  return (
    <div className="review">
      <header className="review__head">
        <img src="/claude-logo.svg" alt="" />
        <div>
          <span className="label">Claude bittet um Review</span>
          <h3>{review.title}</h3>
        </div>
        {reviews.length > 1 && <span className="review__queue">+{reviews.length - 1}</span>}
      </header>

      <p className="review__summary">{review.summary}</p>

      {review.linkType === "text" && <p className="review__note">{review.link}</p>}

      {askingForChanges ? (
        <>
          <textarea
            className="review__feedback"
            autoFocus
            value={feedback}
            placeholder="Was soll Claude anders machen?"
            onChange={(event) => setFeedback(event.target.value)}
            onKeyDown={(event) => {
              if (event.key === "Enter" && (event.metaKey || event.ctrlKey)) sendFeedback();
              if (event.key === "Escape") setFeedbackFor(null);
            }}
          />
          <div className="review__actions">
            <button className="pill" onClick={() => setFeedbackFor(null)}>
              Zurück
            </button>
            <button className="pill pill--solid" onClick={sendFeedback} disabled={!feedback.trim()}>
              Feedback senden
            </button>
          </div>
        </>
      ) : (
        <div className="review__actions">
          <button className="pill" onClick={() => setFeedbackFor(review.id)}>
            Änderung anfordern
          </button>
          <button className="pill pill--solid" onClick={approve}>
            <IconCheck size={13} /> Freigeben
          </button>
          {review.linkType === "url" && (
            <a className="pill pill--link" href={review.link} target="_blank" rel="noreferrer">
              Ansehen <IconChevron size={12} />
            </a>
          )}
        </div>
      )}
    </div>
  );
}
